@if (ticket?.id && customer?.id) {
    <main>
        <div class="ticket-block">
            <div class="logo-container">
                <img class="logo" alt="{{ 'logo' | translate }}" [src]="customer.logo" />
            </div>
            <h1 class="break-word">{{ ticket.title }}</h1>
            #{{ ticket.id }}
            <hr />
            <app-ticket-reply [reply]="firstMessage"></app-ticket-reply>
        </div>
        @for (reply of ticket.messageThread; track reply) {
            <app-ticket-reply
                class="ticket-block"
                [ngClass]="{ highlighted: reply.isNewMessageFromAgent }"
                [reply]="reply">
            </app-ticket-reply>
        }
        <div class="ticket-block" id="new-reply">
            <div class="smile-field-container">
                <quill-editor
                    [(ngModel)]="newReply.message.html"
                    placeholder=""
                    [modules]="quillHelperService.htmlQuillConfig"
                    (onEditorCreated)="onEditorCreated($event)"
                    (onContentChanged)="onReplyChanged()"
                    format="html">
                </quill-editor>
                <sb-quill-emoji-picker
                    [buttonId]="'emoji-btn'"
                    (updateQuillSelection)="updateQuillSelection(quillEditor)"
                    (emojiSelect)="
                        replyTemplateManagerService.chooseReplyTemplate({
                            $event: $event.$event,
                            templateText: $event.emoji,
                            quillEditor: quillEditor,
                            quillRange: quillRange,
                            isSmile: true,
                        })
                    ">
                </sb-quill-emoji-picker>
            </div>

            <div class="attachments-block mb-2">
                @for (attachment of newReply.attachments; track attachment; let index = $index) {
                    <sb-file-preview
                        class="file-container"
                        [attachment]="attachment"
                        [fileIndex]="index"
                        [canBeRemoved]="true"
                        [attachments]="newReply.attachments">
                    </sb-file-preview>
                }
                <div class="clearfix"></div>
            </div>
            <div class="buttons-panel text-end mt-0">
                @if (ticket.constraints.areReplyAttachmentsAllowed) {
                    <button
                        class="btn btn-icon me-1"
                        (click)="openAttachmentsModal()"
                        tooltip="{{ 'Attachments' | translate }}"
                        container="body">
                        <sb-inline-svg
                            class="icon"
                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Attachment icon.svg'">
                        </sb-inline-svg>
                    </button>
                }
                <button
                    class="btn"
                    [disabled]="
                        isSendingReply ||
                        (newReply.message | isInvalidMessage: ticket.constraints : !!newReply.attachments.length : true)
                    "
                    (click)="addReply()">
                    {{ 'send' | translate }}
                </button>
            </div>
        </div>
    </main>
}
@if (isLinkExpired && customer?.id) {
    <div class="ticket-block">
        <div class="logo-container">
            <img class="logo" alt="{{ 'logo' | translate }}" [src]="customer.logo" />
        </div>
        <h1>{{ 'Expired link' | translate }}</h1>
        <p>{{ 'This invite link has expired.' | translate }}</p>
        <p>
            {{ 'If you want a new link, please contact us by email' | translate }},
            <a href="mailto: {{ customer.customerReplyPortalSupportEmail }}">{{
                customer.customerReplyPortalSupportEmail
            }}</a
            >.
        </p>
    </div>
}
